'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * SamplePlanDashboard — the thin standalone screen (#/SamplePlanDashboard[/:IDProject]) that hosts the shareable
 * SamplePlanDashboard provider. It owns only the page chrome: a project picker bar + the dashboard host div. The
 * provider does all the fetching + painting (into #SamplePlanDashboard-Host), so any OTHER view can embed the same
 * dashboard by calling `provider.openInto(idProject, host)` — this view is just one such host.
 */
class SamplePlanDashboardView extends libPictView
{
	get provider() { return this.pict.providers['SamplePlanDashboard']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.mountProjectPicker('#SamplePlanDashboard-ProjectPicker');
			const tmpID = tmpProvider.routeProject;
			if (tmpID) { tmpProvider.openInto(tmpID, '#SamplePlanDashboard-Host'); }
			else { tmpProvider._mount = '#SamplePlanDashboard-Host'; tmpProvider.render(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SamplePlanDashboardView;

module.exports.default_configuration =
{
	ViewIdentifier: 'SamplePlanDashboard',
	DefaultRenderable: 'SamplePlanDashboardWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	// Reusable app-shell Dashboard Mode: the router renders this screen edge-to-edge at the full browser width.
	DashboardMode: true,

	CSS: /*css*/`
		/* Dashboard Mode gives this screen the full browser width (the router drops the app content gutters); zero side
		   padding here keeps the grid edge-to-edge. */
		.spd-page { --spd-gutter: clamp(1rem, 2.2vw, 2rem); padding: 1.25rem var(--spd-gutter) 2rem; }
		.spd-page-bar { display: flex; align-items: center; gap: 0.7rem; margin: 0 0 1.1rem; flex-wrap: wrap; }
		.spd-page-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#7a8794); }
		.spd-page-picker { min-width: 22rem; max-width: 34rem; flex: 1 1 22rem; }
	`,

	Templates:
	[
		{
			Hash: 'SamplePlanDashboard-Template',
			Template: html`
				<section class="section spd-page">
					<div class="spd-page-bar">
						<span class="spd-page-label">Project</span>
						<div id="SamplePlanDashboard-ProjectPicker" class="spd-page-picker"></div>
					</div>
					<div id="SamplePlanDashboard-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'SamplePlanDashboardWrap',
			TemplateHash: 'SamplePlanDashboard-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
